import React from 'react';
import '../Spinner/Spinner.css';
function Spinner() {
  return <div className="loader">Loading...</div>;
}

export default Spinner;
